var emitter = require('../base/emitter'),
	InfoBox = require('../components/gmap-infowindow');

function Contacts(){

	var self = this;
	emitter.on('contacts:init', function(){

		self.init();

	})

	emitter.on('page:leave', function(){

		if(!$('#gmap').length && self.slideInterval){

			clearInterval(self.slideInterval);

		}

	})

}

Contacts.prototype.init = function(){

	var self = this;

	self.slideInterval = setInterval(function(){

		var $slides = $('.contacts-cover_slider .slide');
		var $next;
		if($slides.filter('.active').next().length)
			$next = $slides.filter('.active').next();
		else
			$next = $slides.eq(0);

		$slides.filter('.active').removeClass('active');
		$next.addClass('active');

	},4000)


	$('#gmap').height($('.contacts-map').height());
	$(window).resize(function(){
		$('#gmap').height($('.contacts-map').height());
	})

	var _position = new google.maps.LatLng(45.320687,11.156431);

	var mapOptions = {
		center: _position,
		zoom: 14,
		scrollwheel: false,
		// disableDefaultUI: true,
		styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#9aadb5"},{"visibility":"on"}]}]
	};
	

	var mappa = new google.maps.Map($('#gmap').get(0),mapOptions);
	var infoBubble = new InfoBox({
		 content: '<div class="contacts-infowindow"><p><strong>Sede Legale</strong><br>Via Legnago 45/47<br>37050 Palù<br>Verona<br>ITALIA</div>',
		 disableAutoPan: false, 
		 maxWidth: 288, 
		 pixelOffset: new google.maps.Size(1, 1), 
		 zIndex: null, 
		 boxStyle: { 
			opacity: 1, 
			width: "1px",
			height: "1px"
		 }, 
		 closeBoxMargin: "0px", 
		 closeBoxURL: "",
		 infoBoxClearance: new google.maps.Size(1, 1), 
		 isHidden: false,
		 pane: "floatPane",
		 enableEventPropagation: true
	});

	var marker = new google.maps.Marker({
		position: _position,
		map: self.mappa,
		icon: '  '
	});

	infoBubble.open(mappa, marker)


}

module.exports = Contacts;


/** WEBPACK FOOTER **
 ** ./layouts/contacts.js
 **/